import { IconType } from "react-icons";
import { LuAlertTriangle, LuGift, LuTags, LuUserPlus } from "react-icons/lu";
import { AdminNotification } from "../../hooks/useAdminNotifications";

export const NOTIFICATION_TYPES: { value: AdminNotification["type"]; label: string }[] = [
  { value: "elite_application", label: "Elite applications" },
  { value: "payment_mismatch", label: "Refused payments" },
  { value: "subscription_grant", label: "Subscription grants" },
  { value: "price_change", label: "Price changes" },
];

const STYLE: Record<AdminNotification["type"], { icon: IconType; cls: string }> = {
  elite_application: { icon: LuUserPlus, cls: "bg-hc_F4EBFA text-honeConnectPurple" },
  payment_mismatch: { icon: LuAlertTriangle, cls: "bg-red-50 text-red-600" },
  subscription_grant: { icon: LuGift, cls: "bg-emerald-50 text-emerald-600" },
  price_change: { icon: LuTags, cls: "bg-amber-50 text-amber-600" },
};

export const NotificationIcon = ({ type, size = "h-9 w-9" }: { type: AdminNotification["type"]; size?: string }) => {
  const s = STYLE[type] ?? STYLE.elite_application;
  const Icon = s.icon;
  return (
    <span className={`flex ${size} shrink-0 items-center justify-center rounded-full ${s.cls}`}>
      <Icon className="h-4 w-4" aria-hidden />
    </span>
  );
};

export const timeAgo = (iso: string) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)} d ago`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};
